module.exports = __webpack_public_path__ + "static/ValleyWorxMap-5aed8e949a6f30456befe9b322b0f877.png";